import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import styles from "./OmnibusInfo.module.scss";
import { LEGAL_CONFIG } from "../../../config/legal";

const OmnibusInfo = () => {
	return (
		<div className={styles.page}>
			<div className={styles.container}>
				<h1 className={styles.title}>
          <FormattedMessage
            id="legal.omnibus.title"
            defaultMessage="How the Omnibus directive works on this app"
            values={{ platform: LEGAL_CONFIG.platformName.toUpperCase() }}
          />
        </h1>

				<section className={styles.section}>
					<p>
						Gdy włączasz obniżkę ceny, pokazujemy także informację o najniższej
						cenie z 30 dni przed rozpoczęciem promocji. Wymaga tego tzw.
						dyrektywa Omnibus — ma ona zapewnić klientom jasną informację o
						historii ceny produktu.
					</p>
				</section>

				<section className={styles.section}>
					<h2>Skąd bierze się wartość „najniższa cena z 30 dni”?</h2>
					<p>
						System zapisuje historię zmian ceny i obniżek dla produktu. Przy
						aktywnej promocji analizujemy ostatnie 30 dni i wyświetlamy
						najniższą skuteczną cenę z tego okresu.
					</p>
					<p>
						Jeśli produkt jest dostępny krócej niż 30 dni, bierzemy pod uwagę
						cały dostępny okres od publikacji do startu promocji.
					</p>
					<p>
						Jeżeli produkt został wystawiony od razu z obniżką i nie ma
						wcześniejszej historii cen, jako punkt odniesienia przyjmujemy cenę
						bazową (przed obniżką).
					</p>
				</section>

				<div className={styles.actions}>
					<Link to="/manage-pattern" className={styles.backLink}>
						<FormattedMessage id="legal.omnibus.backLink" defaultMessage="Back to pattern editing" />
					</Link>
				</div>
			</div>
		</div>
	);
};

export default OmnibusInfo;
